import { p as promiseResolve, b as bootstrapLazy } from './index-7ea46152.js';

/*
 Stencil Client Patch Esm v2.17.3 | MIT Licensed | https://stenciljs.com
 */
const patchEsm = () => {
    return promiseResolve();
};

const defineCustomElements = (win, options) => {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(() => {
  return bootstrapLazy([["membership-details",[[0,"membership-details",{"claimMembership":[16],"selectOffer":[16],"membershipData":[8,"membership-data"],"merchantDetails":[8,"merchant-details"],"goBack":[8,"go-back"],"membershipStyle":[16],"selectedMembership":[8,"selected-membership"],"showFull":[32],"showExandCollapse":[32],"merchantDescOpen":[32],"isTermsCollapsed":[32],"isAboutMerchant":[32]}]]],["offer-card",[[0,"offer-card",{"showClaimButton":[16],"callBack":[16],"merchant":[16],"cardStyling":[16],"isClaimableKeyExists":[32],"isAtleastOneClaimable":[32],"isTitleTruncated":[32],"isMerchantNotAvailable":[32]}]]],["offer-details",[[1,"offer-details"]]],["gift-card_2",[[1,"home-page"],[0,"gift-card",{"callBack":[16],"description":[1],"giftcard":[16],"cardStyling":[16],"showBuyButton":[32]}]]]], options);
  });
};

export { defineCustomElements };
